import { ReactNode } from 'react';

import usePermission from 'lib/hooks/usePermission';
import { Permission } from 'lib/permissions';

interface PermissionedProps {
  permission: Permission | Permission[];
  children: ReactNode;
  fallback?: ReactNode;
}

const Permissioned = ({ children, permission, fallback = null }: PermissionedProps) => {
  const hasPermission = usePermission(permission);

  if (hasPermission) {
    return <>{children}</>;
  } else {
    return <>{fallback}</>;
  }
};

export default Permissioned;
